import axios, {
  AxiosError,
  type AxiosInstance,
  type InternalAxiosRequestConfig,
  type AxiosResponse,
} from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api/v1'
export const http: AxiosInstance = axios.create({ baseURL: API_BASE_URL })

const getToken = () => localStorage.getItem('auth_token')

function attachAuthHeaders(config: InternalAxiosRequestConfig) {
  if (config.headers && typeof config.headers.set === 'function') {
    const token = getToken()
    config.headers.set('Authorization', token ? `Bearer ${token}` : '')

    if (config.data instanceof FormData) {
      config.headers.delete('Content-Type')
    } else {
      config.headers.set('Content-Type', 'application/json')
    }
  }
}

http.interceptors.request.use((config) => {
  attachAuthHeaders(config)
  return config
})

http.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      const isLoginRequest = error.config?.url?.includes('/auth/login')

      if (!isLoginRequest) {
        localStorage.removeItem('auth_token')
        localStorage.removeItem('user_data')

        if (window.location.pathname !== '/') {
          window.location.href = '/'
        }
      }
    }

    return Promise.reject(error)
  },
)

export const rawHttp: AxiosInstance = axios.create({ baseURL: API_BASE_URL })

export default http
